import { render } from "./Paymentsr.vue?vue&type=template&id=2f3234c0"
import script from "./Paymentsr.vue?vue&type=script&lang=js"
export * from "./Paymentsr.vue?vue&type=script&lang=js"
script.render = render

export default script